import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import TextField from "../Reusable/TextInput";
import { tw } from "@careinfo/tailwind";
import { templateValidationForm } from "../../utils/validationSchemas";
import { Group, Panel, Separator } from "react-resizable-panels";
import CodeField from "../Reusable/CodeField";
import DOMPurify from "dompurify";
import TabPanel from "../Reusable/Tab";

const CreateTemplate = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    control,
    watch,
  } = useForm<any>({
    resolver: yupResolver(templateValidationForm),
  });
  const { handleCreate, isLoading } = props;
  const Html = watch("html");
  const sanitizeTemplateForPreview = (html: string) => {
    return html;
    // .replace(/\{%\s*load[\s\S]*?%\}/g, "")
    // .replace(/\{%\s*(for|if|with)[\s\S]*?%\}/g, "<!-- django:start -->")
    // .replace(/\{%\s*(endfor|endif|endwith)\s*%\}/g, "<!-- django:end -->")
    // .replace(/\{%\s*else\s*%\}/g, "<!-- django:else -->")
    // .replace(/\{\{[\s\S]*?\}\}/g, "____")
  };
  return (
    <>
     
          <FormLayout
            handleSubmit={handleSubmit}
            handleFormSubmit={handleCreate}
            setError={setError}
            buttonLabel={"Create"}
            isLoading={isLoading}
          >
            <div className={tw`grid grid-cols-2  gap-x-4 mx-4`}>
              <TextField
                label={"Template Name "}
                register={register("name")}
                errors={errors?.name}
              />
              <TextField
                label={"Slug"}
                register={register("slug")}
                errors={errors?.slug}
              />
              <TextField
                label={"Description"}
                register={register("description")}
                errors={errors?.description}
              />
            </div>
            <div className="mx-4">
              <div className={tw`flex justify-between items-center`}>
                <label htmlFor="">HTML Code</label>
              </div>
              <Group orientation="horizontal" className={tw`h-[450px]`}>
                <Panel defaultSize={50} minSize={30}>
                  <CodeField control={control} name="html" />
                </Panel>
                <Separator
                  className={tw`w-[2px] bg-gray-200 cursor-col-resize hover:bg-gray-300 transition `}
                />
                <Panel defaultSize={50} minSize={30}>
                  <div className={tw`h-full p-4 border bg-white overflow-auto`}>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(
                          sanitizeTemplateForPreview(Html || "")
                        ),
                      }}
                    />
                  </div>
                </Panel>
              </Group>
            </div>
          </FormLayout>,
    </>
  );
};

export default CreateTemplate;
